export const VENDORS = ['dell', 'hp', 'lenovo'];
export const SEVERITIES = ['critical', 'warning', 'info', 'ok'];
export const EVENT_CATEGORIES = [
    'storage',
    'thermal',
    'power',
    'network',
    'system',
    'security',
    'other',
];
/** Severity → emoji used by Telegram and Slack notifiers. */
export const SEVERITY_EMOJI = {
    critical: '🔴',
    warning: '🟡',
    info: '🔵',
    ok: '🟢',
};
/** Severity → ordering weight (higher = more severe). Useful for sorting. */
export const SEVERITY_WEIGHT = {
    ok: 0,
    info: 1,
    warning: 2,
    critical: 3,
};
//# sourceMappingURL=index.js.map